

<form class="form-signin text-center">
  <div>
    <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
  </div>
  {{'Common.ResetyourPassword' | translate}}
  <br />
  <h1 class="h3 mb-3 font-weight-normal">{{ 'Login.Verify' | translate }}</h1>
  <h1 class="h3 mb-3 font-weight-normal">{{ 'Login.SecurityCode' | translate }}</h1>


  <label for="inputPassword" class="sr-only">{{ 'Login.InputPassword' | translate }}</label>

  <input type="password" class="form-control" placeholder="Password" maxlength="25" [(ngModel)]="user.password" required (keyup)="checkIfMatchingPasswords($event)" [ngModelOptions]="{standalone: true}">
  <input type="password" class="form-control" placeholder="Re-type Password" [(ngModel)]="user.confirmPassword" [ngModelOptions]="{standalone: true}" required (keyup)="checkIfMatchingPasswords($event)">
  <div class="text-left">
    <label *ngIf="submittedApplicationForm && notEquivalent " class="text-danger">{{'Common.Passworddoesnotmatch' | translate}}</label>
  </div>
  <button class="btn btn-lg btn-primary btn-block btn_submit " type="submit" (click)="ChangePassword()">{{ 'Login.Submit' | translate }}</button>
  <br />
  <div class="password-strength">
    <ng9-password-strength-bar *ngIf="user.password" [passwordToCheck]="user.password"
                               (onStrengthChanged)="strengthChanged()">
    </ng9-password-strength-bar>
  </div>
  <label class="text-danger text-left">{{common?.message}}</label>

  <br />
  <br />
  <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
</form>










